export default __webpack_public_path__ + "static/media/logo-08-achat-hotels.60496c75.png";